if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      const mediaVariantMap = this.querySelector('[data-media-variant-map]');
      const mediaVariantEntries = mediaVariantMap ? JSON.parse(mediaVariantMap.textContent) : [];
      this.variantValuesByMediaId = new Map(mediaVariantEntries.map((entry) => [entry.mediaId, entry.value]));
      this.variantSelectionFromSwipe = null;
      this.mql = window.matchMedia('(min-width: 750px)');

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      if (!this.elements.thumbnails) return;

      this.elements.thumbnails.addEventListener('click', this.onThumbnailClick.bind(this));
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onThumbnailClick(event) {
      const button = event.target.closest('button');
      const mediaToSwitch = button?.closest('[data-target]');
      if (!mediaToSwitch || !this.elements.thumbnails.contains(mediaToSwitch)) return;

      event.preventDefault();
      this.setActiveMedia(mediaToSwitch.dataset.target, false, true);
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      if (this.elements.thumbnails) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
      }
      this.selectVariantForMedia(event.detail.currentElement);
    }

    selectVariantForMedia(mediaElement) {
      const variantValue = mediaElement.dataset.variantValue || this.variantValuesByMediaId.get(mediaElement.dataset.mediaId);
      if (!variantValue) return;

      const productSection = this.closest('.shopify-section') || document;
      const variantSelects = productSection.querySelector('variant-selects[data-primary]');
      if (!variantSelects) return;

      const controls = Array.from(variantSelects.querySelectorAll('input[type="radio"], option'));
      const control = controls.find((item) => item.value === variantValue);
      if (!control) return;

      if (control.tagName === 'OPTION') {
        const select = control.closest('select');
        if (!select || select.value === variantValue) return;
        this.variantSelectionFromSwipe = { mediaId: mediaElement.dataset.mediaId, value: variantValue };
        select.value = variantValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      if (control.checked) return;
      this.variantSelectionFromSwipe = { mediaId: mediaElement.dataset.mediaId, value: variantValue };
      control.click();
    }

    consumeVariantSelectionFromSwipe(mediaId) {
      const variantSelection = this.variantSelectionFromSwipe;
      this.variantSelectionFromSwipe = null;
      return variantSelection?.mediaId === mediaId;
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true, preserveViewerPosition = false) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails && !preserveViewerPosition) {
          const viewerSlider = this.elements.viewer.slider || activeMedia.parentElement;
          if (this.mql.matches) {
            viewerSlider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
          } else {
            const mediaItems = Array.from(viewerSlider.children).filter((item) => item.matches('[data-media-id]'));
            const mediaIndex = mediaItems.indexOf(activeMedia);
            const targetLeft = activeMedia.offsetLeft || Math.max(mediaIndex, 0) * viewerSlider.clientWidth;
            viewerSlider.scrollTo({ left: targetLeft, behavior: 'auto' });
            viewerSlider.scrollLeft = targetLeft;
          }
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
